<template>

        <!-- Fine Inizio Piatto -->
              <v-card style="padding:2px;margin:1px" dense :flat="flat_menu">
                <v-row align="center"  no-gutters>
                  <v-col cols="12" sm="2" align="left" v-if="show_images">
                    <v-img
                      :src="piatto.url|| 'http://www.lacervarola.it/wp-content/uploads/2015/09/icona-ristorante.png'"
                      width="100%"
                      :height="$vuetify.breakpoint.name!='xs'?'100%':'75px'"
                      aspect-ratio="1"
                    ></v-img>
                  </v-col>
                  <v-col cols="10" :sm="show_images?8:10" align="left" justify="center">
                    <h2 class="font-weight-light" style="font-size:1.1em">{{piatto.descrizione}}</h2>
                    <div>
                      <span
                        class="font-weight-light font-italic" style="font-size:0.7em"
                        v-for="(ingrediente,index) in piatto.ingredienti"
                        :key="index"
                      >{{index > 0?',':''}} {{ingrediente.descrizione}}{{ingrediente.allergenico=='-1'?'*':''}}</span>
                    </div>
                  </v-col>
                  <v-col cols="2" sm="2" align="right">
                    
                    <h3 align="right" style="font-size:1.1em">€ {{piatto.prezzo/100}}</h3>
                    <v-btn v-if="enable_orders && canadd" color="orange" @click="$emit('ordinapiatto', componipiatto(piatto))"><v-icon>mdi-plus</v-icon></v-btn>
                  </v-col>
                </v-row>
              </v-card>
              <!-- Fine Piatto -->

</template>
<script>
export default {     
    props:['piatto','raggruppamento','canadd','show_images','flat_menu','enable_orders'],
    data: () => ({        
    }),
    methods:{
      //inserisco nel piatto il gruppo di appartentenenza per disciplinare l'inserimento dei piatti nelle comande del menu ristorante
      componipiatto(piatto){
        let p = piatto;
        piatto.sottogruppo = this.raggruppamento;
        if(!piatto.sottogruppo.ordinato){
          piatto.sottogruppo.ordinato = 0;
        }
        return p
      }
    }
    
}
</script>
